import { useState } from 'react';
import { Package } from 'lucide-react';
import { cn } from '@/lib/utils';

export const BrandIcon = ({ icon: Icon, className }) => (
  <span aria-hidden="true" className={cn('brand-icon inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-brand-orange/25 bg-brand-orange/10 text-brand-navy dark:text-brand-cream', className)}>
    <Icon className="h-6 w-6" strokeWidth={1.7} />
  </span>
);

export const BrandLogo = ({ footer = false }) => (
  <img src="/media/logo-bodegon-transparent.png" width="441" height="467" alt="Bodegón Mi Barrio — tu mercado online de confianza" data-testid={footer ? 'footer-logo' : 'header-logo'} className={footer ? 'brand-logo-footer' : 'brand-logo-header'} />
);

export const BarrioPuntosLogo = ({ variant = 'band', testId, className }) => (
  <img src="/media/barrio-puntos/logo-large.png" srcSet="/media/barrio-puntos/logo-small.png 182w, /media/barrio-puntos/logo-large.png 485w" sizes={variant === 'hero' ? '(min-width: 768px) 180px, 140px' : '68px'} width="485" height="512" alt="Barrio Puntos — programa de lealtad" data-testid={testId || `barrio-puntos-logo-${variant}`} className={cn('barrio-puntos-logo', `barrio-puntos-logo--${variant}`, className)} decoding="async" />
);

export const EditorialImage = ({ src, alt, className, testId, eager = false, ...props }) => {
  const [failed, setFailed] = useState(false);
  return failed || !src ? (
    <span role="img" aria-label={alt} data-testid={`${testId}-fallback`} className={cn('flex h-full w-full items-center justify-center bg-muted text-muted-foreground', className)}><Package className="h-10 w-10" strokeWidth={1.5} /></span>
  ) : <img {...props} src={src} alt={alt} data-testid={testId} loading={eager ? 'eager' : 'lazy'} fetchPriority={eager ? 'high' : 'auto'} decoding="async" onError={() => setFailed(true)} className={className} />;
};
